import React, { useEffect, useState } from "react";
import { FaFileAlt, FaDownload, FaTrash } from "react-icons/fa";
import { Modal } from "../shared";
import { useLazyGetTaskDownloadUrlQuery } from "../../store";
import useAuth from "../../Hooks/useAuth";
import { formatFileSize } from "./taskConstants";
import { useNestedOverlay } from "./nestedOverlay";

const urlOf = (res) => res?.data?.data?.url || res?.data?.url;

function Thumb({ att, fetchUrl, onOpen }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchUrl(att._id, true).then((u) => alive && setSrc(u));
    return () => {
      alive = false;
    };
  }, [att._id, fetchUrl]);
  return (
    <button
      type="button"
      onClick={() => onOpen(att, src)}
      className="w-20 h-20 rounded-lg border border-gray-200 overflow-hidden bg-gray-50 flex items-center justify-center"
      title={att.name}
    >
      {src ? <img src={src} alt={att.name} className="w-full h-full object-cover" /> : <FaFileAlt className="text-gray-400" />}
    </button>
  );
}

// onOpen(att) verilirse resme tıklamada varsayılan büyütme yerine o çağrılır.
// modalZIndex: çekmece (z 9999) içinde önizleme modal'ı üstte kalsın diye.
function AttachmentList({ attachments = [], onOpen, onDelete, modalZIndex }) {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const [getUrl] = useLazyGetTaskDownloadUrlQuery();
  const [preview, setPreview] = useState(null);
  useNestedOverlay(Boolean(preview));

  const fetchUrl = React.useCallback(
    async (attachmentId, inline) => {
      try {
        return urlOf(await getUrl({ token, attachmentId, inline }));
      } catch (e) {
        return null;
      }
    },
    [getUrl, token]
  );

  if (!attachments.length) return null;
  const images = attachments.filter((a) => a.isImage);
  const files = attachments.filter((a) => !a.isImage);

  const del = (a) =>
    a.can?.delete && (
      <button
        type="button"
        onClick={() => onDelete && onDelete(a)}
        className="text-gray-400 hover:text-red-600 p-1"
        title="Sil"
        aria-label={`${a.name} sil`}
      >
        <FaTrash className="w-3.5 h-3.5" />
      </button>
    );

  return (
    <div className="space-y-3">
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {images.map((a) => (
            <div key={a._id} className="relative group">
              <Thumb
                att={a}
                fetchUrl={fetchUrl}
                onOpen={(att, src) => (onOpen ? onOpen(att) : setPreview({ att, src }))}
              />
              {a.can?.delete && (
                <span className="absolute top-0.5 right-0.5 bg-white/90 rounded">{del(a)}</span>
              )}
            </div>
          ))}
        </div>
      )}
      {files.map((a) => (
        <div key={a._id} className="flex items-center gap-3 rounded-lg border border-gray-200 px-3 py-2">
          <FaFileAlt className="text-gray-400 shrink-0" aria-hidden="true" />
          <div className="min-w-0 flex-1">
            <p className="text-sm text-gray-800 truncate">{a.name}</p>
            <p className="text-xs text-gray-500">{formatFileSize(a.size)}</p>
          </div>
          <button
            type="button"
            onClick={async () => {
              const u = await fetchUrl(a._id, false);
              if (u) window.open(u, "_blank", "noopener");
            }}
            className="text-gray-500 hover:text-main p-1"
            title="İndir"
            aria-label={`${a.name} indir`}
          >
            <FaDownload className="w-3.5 h-3.5" />
          </button>
          {del(a)}
        </div>
      ))}
      <Modal open={!!preview} onClose={() => setPreview(null)} maxWidth="full" zIndex={modalZIndex}>
        <Modal.Header title={preview?.att?.name} onClose={() => setPreview(null)} />
        <Modal.Body className="flex justify-center">
          {preview?.src && <img src={preview.src} alt={preview.att.name} className="max-h-[75vh] max-w-full object-contain" />}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AttachmentList;
